import axios from './axios';

export const setPhone = (data) => axios.post('/authentication/admin/2fa/v1/phone', data);

export const generateCode = () => axios.post('/authentication/admin/2fa/v1/sms');

export const verifyCode = (data) => axios.post('/authentication/admin/2fa/v1/check', data);
